import useSWR from "swr";

import { userServices } from "../../../../../helpers/services/UserServices";
import {
    BeneficiaresManagementEnum,
    ResponseStatusEnum,
} from "../../../../../helpers/GlobalEnum";

/** Devuelve el último elemento de un arreglo (o null si está vacío). */
const pickLatest = (arr = []) =>
    Array.isArray(arr) && arr.length ? arr[arr.length - 1] : null;

/**
 * Consulta la información del titular (CUB).
 * GET /api/usuario/cub/{cubId}/
 */
const fetchUserInformation = async (cubId) => {
    const { data, status } = await userServices.userInformation(cubId);
    if (status !== ResponseStatusEnum.OK) return { userData: {}, consolidated: null };

    const archivos = data?.archivos ?? {};
    const consolidado = pickLatest(archivos[BeneficiaresManagementEnum.CONSOLIDATED]);

    return { userData: data ?? {}, consolidated: consolidado?.ruta ?? null };
};

/**
 * Carga cacheada de la información del titular vía SWR.
 * - Una sola fuente por CUB (dedup + caché entre navegaciones).
 * - `keepPreviousData` evita que la UI parpadee al cambiar de titular.
 *
 * @param {number|string} cubId - ID del titular (CUB).
 */
export function useUserInformation(cubId) {
    const { data, isLoading } = useSWR(
        cubId ? ["user-information", cubId] : null,
        () => fetchUserInformation(cubId),
        { revalidateOnFocus: false, dedupingInterval: 5000, keepPreviousData: true }
    );

    return {
        userData: data?.userData ?? {},
        consolidated: data?.consolidated ?? null,
        isLoading,
    };
}